export default __webpack_public_path__ + "static/5-efb8ff51f74fa305c4e3c2ba422eceb5.webp";